import Api from "./Api";

class ReportApi extends Api {
  getList(data: object) {
    const url = this.prepareUrl("/disclosurecode/private/report/getlist");
    return this.requestGetList(url, data);
  }

  get(id: number | undefined | string = undefined, data: object = {}) {
    const url = this.prepareUrl("/disclosurecode/private/report/", id);
    return this.requestGet(url, data, "object");
  }

  unlockRequest(id: number) {
    const url = this.prepareUrl(
      "/disclosurecode/private/report/unlockrequest",
      id
    );
    return this.requestGet(url, {});
  }

  unlock(id: number) {
    const url = this.prepareUrl("/disclosurecode/private/report/unlock/", id);
    return this.requestGet(url, {});
  }

  getReportUrl() {
    const url = `${this.url}/disclosurecode/private/report/`;
    return url;
  }

  getOrganizationReportLinkUrl() {
    const url = `${this.url}/disclosurecode/private/report/organizationlink/`;
    return url;
  }

  getStatus() {
    const url = `${this.url}/disclosurecode/private/report/status/`;
    return this.requestGet(url, {}, "object");
  }

  getSummary(year?: number): any {
    const url = this.prepareUrl(`/disclosurecode/private/summary/`, year);
    return this.requestGet(url, {}, "object");
  }
}

export default new ReportApi();
